import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const AdminRolesRoutes: Routes = [
  {
    path: "roles",
    loadComponent: () =>
      import("./admin-roles/admin-roles.component").then(
        (m) => m.AdminRolesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./admin-roles-list/admin-roles-list.component").then(
            (m) => m.AdminRolesListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./admin-roles-form/admin-roles-form.component").then(
            (m) => m.AdminRolesFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./admin-roles-form/admin-roles-form.component").then(
            (m) => m.AdminRolesFormComponent,
          ),
      },
    ],
  },
];
